angular.module('cfn').controller('stockReportController', [
  '$scope',
  '$log',
  '$timeout',
  '$location',
  'stockService',
  function($scope, $log, $timeout, $location, stockService) {
    // Model =================================================

    $scope.reportParams = {
      date: new Date().getTime(),
      currentDate: new Date().getTime(),
      userName: app.credentials.person.combinedName,
      editmode: false
    };

    $scope.switchVisible = $location.hash() != ''; // Show demo if url ends with #DEMO

    $scope.report = {}; // filled by $scope.loadData()
    $scope.UnitMasterEnum = {
      MASS: 'Fest',
      LIQUID: 'Flüssig',
      VOLUME: 'Volumen',
      QUANTITY: 'Mengen'
    };
    $scope.capacityEnum = enums.UnitsCapacityEnum.options.map(function(value) {
      return {
        value: value,
        label: enums.UnitsCapacityEnum[value],
        group: $scope.UnitMasterEnum[value.split('_')[0]]
      };
    });
    // Functions ==============================================

    $scope.$watch('reportParams.date', function(newVal, oldVal) {
      if (newVal != oldVal) $scope.loadData();
    });

    // Focus first Input-Field in Edit-Mode
    $scope.$watch('reportParams.editmode', function(newVal, oldVal) {
      if (newVal == true)
        $timeout(function() {
          var e = angular.element('.stockReport input')[1];
          if (e) {
            e.focus();
            e.select();
          }
        });
    });

    $scope.loadData = function() {
      $scope.report = {}; // show "please wait"
      stockService
        .loadData($scope.reportParams.date)
        .then(function(reportData) {
          $scope.report = reportData;
        });
    };

    $scope.saveData = function() {
      stockService
        .saveData($scope.report.list, $scope.reportParams.date)
        .then(function(reportData) {});
    };

    /*
         * currently not in use
         */
    /*
        $scope.jumpTo = function (row) {
            var title = i18nFilter("fe.analysis.stockReport.xxx", "zurück zur Lagerbestandsliste");
            var url = "core/" + row.url + "/" + row.typeId;
            if (row.stocktype != 'SysHarvestType') //
            app.gotoWithBackButton(url, "analyse/stockReport", title, "stockReportController",
                       {
                           params: $scope.reportParams
                       });
        };
        */
    // Init ====================================================

    $scope.loadData();
  }
]);
